import React, { useState } from "react";
import {
  List,
  Link,
  ListItem,
  ListItemContent,
  ListItemDescription,
  StyledTile,
  StyledVectorDown,
  StyledVectorUp,
  TileHeader,
  NewConcept,
  DetailedItemInformation,
  CostLabel,
  CostLabelStandard
} from "./styled";
import { InterestLevelBar } from "./InterestLevelBar";
import { checkDaysSincePublication } from "../../utils/checkDaysSincePublication";

export const Tile = ({ data }) => {
  const [openItem, setOpenItem] = useState(null);

  const toggleItem = (index) => {
    setOpenItem((prevIndex) => (prevIndex === index ? null : index));
  };

  const { companyStatus, features } = data;
  const isPremium = companyStatus === "5";

  return (
    <StyledTile>
      <TileHeader>{features.tileHeader}</TileHeader>
      <List>
        {features.result.map((item, index) => (
          <ListItem key={item.id}>
            {openItem === index ? (
              <StyledVectorUp onClick={() => toggleItem(index)} />
            ) : (
              <StyledVectorDown onClick={() => toggleItem(index)} />
            )}
            <ListItemDescription>
              {item.name ?? item.title}
              {checkDaysSincePublication(item.createdTime) ? <NewConcept>Nowość</NewConcept> : ""}
            </ListItemDescription>
            <DetailedItemInformation>
              {item.interestLevel ? <InterestLevelBar level={item.interestLevel} /> : ""}
              {features.optionalFeatures ? (
                isPremium && item.costPremium ?
                <> <CostLabelStandard>{item.cost}</CostLabelStandard><CostLabel>{item.costPremium}</CostLabel></>
               
                
                :
                <CostLabel>{item.cost}</CostLabel>
              ) : (
                ""
              )}
              <Link href={item.link} target="_blank">Zobacz szczegóły</Link>
            </DetailedItemInformation>
            {openItem === index ? (
              <ListItemContent
                dangerouslySetInnerHTML={{ __html: item.shortContent ?? item.description }}
              ></ListItemContent>
            ) : (
              ""
            )}
          </ListItem>
        ))}
      </List>
    </StyledTile>
  );
};
